<template lang="html">
  <div class="admin-competitions-wrapper">
    <div class="title">
      <!-- {{$t('nav.competitions')}} -->
      Konkursi

    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>{{$t('competitions.main.competition')}}</td>
            <td>{{$t('competitions.main.status')}}</td>
            <td style="width: 180px;"></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="competition in competitions" :key="competition.cmp_id">
            <td>
              {{ competition.cmp_name }}
            </td>
            <td>
              {{ $t( getStatusName(competition)) }}
            </td>
            <td>
              <div @click="openEditModal(competition)" class="btn">
                {{$t('competitions.main.changeStatus')}}
              </div>
            </td>
            <td>
              <div
                @click="openRestoreModal(competition)"
                v-if="competition.cmp_deleted"
                class="btn"
              >
                {{$t('competitions.main.undo')}}
              </div>
              <div v-else @click="openConfirmModal(competition)" class="btn">
                {{$t('competitions.main.delete')}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="action-wrapper">
      <div v-if="competitions.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
      <div @click="openCreateModal" class="btn">
        {{$t('competitions.main.newCompetition')}}
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'AdminCompetitions',
  data () {
    return {
      competitions: [],
      page: 1,
      pageCount: 0,
      search: null
    }
  },
  activated () {
    this.getCompetitions()
  },
  methods: {
    openConfirmModal (comp) {
      let modalData = {
        title: this.$t('competitions.main.deleteContest'),
        text:
              this.$t('competitions.main.sureToUpdate'),
        ok: () => {
          this.deleteCompetition(comp)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    async deleteCompetition (comp) {
      try {
        let params = {
          id: comp.cmp_id,
          delete: 1
        }
        let res = await api.deleteCompetition(params)
        this.$toast.success(this.$t('competitions.main.successDeleteCont'), {
          duration: 8000
        })
      } catch (e) {
        this.$toast.error(this.$t('competitions.tr.error'), {
          duration: 8000
        })
      } finally {
        this.getCompetitions()
      }
    },
    openRestoreModal (comp) {
      let modalData = {
        title: this.$t('competitions.main.undoContest'),
        ok: () => {
          this.restoreCompetition(comp)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    async restoreCompetition (comp) {
      try {
        let params = {
          id: comp.cmp_id
        }
        let res = await api.deleteCompetition(params)
        this.$toast.success(this.$t('competitions.main.successUndoContest'), {
          duration: 8000
        })
      } catch (e) {
        this.$toast.error(this.$t('competitions.main.errorUndoContest'), {
          duration: 8000
        })
      } finally {
        this.getCompetitions()
      }
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.competitions = []
      this.getCompetitions()
    },
    async getCompetitions () {
      try {
        let params = {
          page: this.page
        }
        if (this.search && this.search !== '') {
          params.search = this.search
        }
        let res = await api.getAdminCompetitions(params)
        this.competitions = res.data.data
        this.pageCount = res.data.page_count
      } catch (e) {
        console.log(e)
      }
    },
    getStatusName (comp) {
      if (comp.cmp_active) {
        return  'competitions.status.active'
      } else if (comp.cmp_upcoming) {
        return 'competitions.status.next'
      } else if (comp.cmp_archived) {
        return  'competitions.status.archived'
      } else if (comp.cmp_next_year) {
        return  'competitions.status.nextYear'
      }
    },
    async editComp (comp, status) {
      let params = {}
      params.id = comp.cmp_id
      params.cmp_name = comp.cmp_name
      params.cmp_description = comp.cmp_description
      params.cmp_theme = comp.cmp_theme
      params.cmp_from_post = comp.cmp_from_post
      params.cmp_to_post = comp.cmp_to_post
      params.cmp_from_vote = comp.cmp_from_vote
      params.cmp_to_vote = comp.cmp_to_vote
      params[status] = 1
      try {
        await api.editCompetition(params)
        this.$toast.success(this.$t('competitions.main.successEditCont'), {
          duration: 8000
        })
      } catch (e) {
        if (e.response.data.message === 'active-exists') {
          this.$toast.error(this.$t('competitions.works.active_exists'), {
            duration: 8000
          })
        }
      } finally {
        this.getCompetitions()
      }
    },
    getFormatedDate (date) {
      return this.$moment
        .utc(date)
        .local()
        .format('YYYY-MM-DDTHH:mm')
    },
    openEditModal (comp) {
      comp.cmp_from_post = comp.cmp_from_post
        ? this.getFormatedDate(comp.cmp_from_post)
        : null
      comp.cmp_from_vote = comp.cmp_from_vote
        ? this.getFormatedDate(comp.cmp_from_vote)
        : null
      comp.cmp_to_post = comp.cmp_to_post
        ? this.getFormatedDate(comp.cmp_to_post)
        : null
      comp.cmp_to_vote = comp.cmp_to_vote
        ? this.getFormatedDate(comp.cmp_to_vote)
        : null

      let modalData = {
        title: this.$t('competitions.main.editContest'),
        comp: comp,
        ok: status => {
          this.editComp(comp, status)
        }
      }
      let params = {
        modalData: modalData,
        component: 'changeCompetitionStatusModal'
      }
      eventBus.$emit('openModal', params)
    },
    async createComp (comp, status, age, type) {
      let params = {}
      params.cmp_name = comp.cmp_name
      params.cmp_description = comp.cmp_description
      params.cmp_theme = comp.cmp_theme
      params.cmp_from_post = comp.cmp_from_post
      params.cmp_to_post = comp.cmp_to_post
      params.cmp_from_vote = comp.cmp_from_vote
      params.cmp_to_vote = comp.cmp_to_vote
      params[status] = 1
      params.cmp_age = age
      params.cmp_type = type

      try {
        await api.createCompetition(params)
        this.$toast.success(this.$t('competitions.works.successCreate'), {
          duration: 8000
        })
      } catch (e) {
        if (e.response.data.message === 'active-exists') {
          this.$toast.error(this.$t('competitions.works.active_exists'), {
            duration: 8000
          })
        }
      } finally {
        this.getCompetitions()
      }
    },
    openCreateModal () {
      let comp = {
        cmp_deleted: null,
        cmp_description: '',
        cmp_from_post: null,
        cmp_from_vote: null,
        cmp_name: '',
        cmp_theme: '',
        cmp_to_post: null,
        cmp_to_vote: null
      }
      let modalData = {
        title: this.$t('competitions.main.createContest'),
        comp: comp,
        type: 'create',
        ok: (status, age, type) => {
          this.createComp(comp, status, age, type)
        }
      }
      let params = {
        modalData: modalData,
        component: 'changeCompetitionStatusModal'
      }
      eventBus.$emit('openModal', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-competitions-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
  .input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;

    textarea {
      width: 100%;
      box-sizing: border-box;
    }
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .btn:last-child {
      margin-left: 10px;
    }
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .btn:last-child {
      margin-left: 10px;
    }
  }
}
</style>
